import {combineReducers} from 'redux';
import {statsReducer} from './statsReducer';

export const profileReducer = combineReducers({
  stats: statsReducer,
});
